<template>
  <section class="map">
    <div
      v-if="includeAddress || includeMapLink"
      class="map__details">
      <h4
        v-if="includeAddress"
        v-html="map.address"></h4>
      <a
        v-if="includeMapLink"
        class="map__link"
        :href="`https://www.google.com/maps/dir/?api=1&origin=here&destination=${map.address}`"
        target="_blank"
        rel="noopener noreferrer">
        <h4>
          Google Maps →
        </h4>
      </a>
    </div>
    <div
      ref="map"
      id="map"></div>
  </section>
</template>

<script>
import Maps from '@/maps'
import { addGoogleMaps, googleMapStyles } from '@/utils'

export default {
  name: 'Map',
  props: {
    map: {
      type: Object,
      default: null
    },
    locations: {
      type: Array,
      default: null
    },
    colour: {
      type: String,
      default: 'colour'
    },
    includeAddress: {
      type: Boolean,
      default: false
    },
    includeMapLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Maps,
      addGoogleMaps,
      googleMapStyles,
      googleMap: null,
      googleMapMarkers: [],
      googleMapInfoWindows: [],
      windowWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    }
  },
  async created() {
    setTimeout(() => {
      this.loadGoogleMaps()

      setTimeout(() => {
        this.locations.forEach(location => {
          this.addGoogleMapsLocation(location)
        })
      }, 0)

      setTimeout(() => {
        this.googleMapInfoWindows[0].open(this.googleMap, this.googleMapMarkers[0])
      }, 800)
    }, 500)
  },
  methods: {
    loadGoogleMaps() {
      this.googleMap = new window.google.maps.Map(
        this.$refs.map, {
          zoom: this.windowWidth > 768 ? this.map.zoom : this.map.zoom - 2,
          center: {
            lat: this.map.lat,
            lng: this.map.lng
          },
          // mapTypeId: this.map.mapTypeId,
          styles: this.colour === 'colour' ? null : this.googleMapStyles(),
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: true,
          fullscreenControl: false
        }
      )
    },
    addGoogleMapsLocation(location) {
      let marker = new window.google.maps.Marker({
        position: {
          lat: location.location.lat,
          lng: location.location.lng
        },
        icon: {
          fillColor: location.color,
          path: google.maps.SymbolPath.CIRCLE,
          scale: this.windowWidth > 768 ? 5 : 3.5,
          strokeColor: location.color,
          strokeWeight: this.windowWidth > 768 ? 10 : 7
        },
        /* icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 5
        }, */
        map: this.googleMap,
      })

      let infoWindow = new google.maps.InfoWindow({
        content: this.getGoogleMapsInfoWindowContent(location),
        maxWidth: 400
      });

      marker.addListener('click', function() {
        infoWindow.open(this.googleMap, marker);
      })

      this.googleMapMarkers.push(marker)
      this.googleMapInfoWindows.push(infoWindow)
    },
    getGoogleMapsInfoWindowContent(location) {
      const container = document.createElement('div')
      const title = document.createElement('h5')
      const description = document.createElement('p')

      title.textContent = location.title
      description.innerHTML = location.description

      container.appendChild(title)
      container.appendChild(description)

      return container
    }
  }
}
</script>

<style lang="scss" scoped>
.map {
  width: 100%;
  background-color: $grey;
  padding: $page-padding;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  &__details {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  #map {
    border-radius: 1.875rem;
    overflow: hidden;
    box-shadow: 0 0.125rem 1.375rem rgba(193, 193, 193, 0.5);
    width: calc(100vw - (#{$padding} * 8));
    height: calc((100vw - (#{$padding} * 8)) * 0.667);
    max-height: calc((#{$content-width} - (#{$padding} * 8)) * 0.667);
    margin: #{$padding * 6} #{$padding * 6};
  }

  @include mobile {
    padding: #{$padding * 1};
    &__details {
      flex-direction: column;
      margin: $padding;
    }
    #map {
      width:calc(80vw - #{$padding * 2});
      height:50vh;
      min-height: 400px;
      margin: $padding $page-padding;
      width: 100%;
    }
  }
}
</style>
